import type { GridCell } from '@glideapps/glide-data-grid';

export type Cache = Map<number, GridCell[]>;

export class ContentCache {
  private cachedContent: Cache = new Map();

  get(colIndex: number, rowIndex: number) {
    const colCache = this.cachedContent.get(colIndex);

    if (typeof colCache === 'undefined') return undefined;

    if (typeof colCache[rowIndex] === 'undefined') return undefined;

    return colCache[rowIndex];
  }

  set(colIndex: number, rowIndex: number, value: GridCell) {
    let rowCache = this.cachedContent.get(colIndex);

    if (typeof rowCache === 'undefined') {
      this.cachedContent.set(colIndex, (rowCache = []));
    }

    rowCache[rowIndex] = value;
  }

  delete(rows: number[]) {
    for (const row of rows.slice().reverse()) {
      for (const col of this.cachedContent.keys()) {
        const rowCache = this.cachedContent.get(col);
        if (typeof rowCache === 'undefined') continue;
        rowCache.splice(row, 1);
      }
    }
  }

  getRow(rowIndex: number) {
    const row: (GridCell | undefined)[] = [];
    for (const colIndex of this.cachedContent.keys()) {
      const column = this.cachedContent.get(colIndex);
      if (typeof column === 'undefined') {
        row.push(undefined);
      } else {
        row.push(column[rowIndex]);
      }
    }
    return row;
  }

  getCacheMap() {
    return this.cachedContent;
  }

  clear() {
    return this.cachedContent.clear();
  }
}
